<template>
  <div id="grid-centro">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <!-- TABLA DE CENTROS -->
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="evidencia"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.tipoEvidencia.descripcion }}
              </td>
              <td class="text-xs-left">Supervisor</td>
              <div class="text-xs-center">
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Descargar evidencia"
                    @click="downloadEvidencia()"
                  >
                    <v-icon>cloud_download</v-icon> </v-btn
                  >Descargar evidencia
                </td>
              </div>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                  >
                    <v-icon>cloud_download</v-icon> </v-btn
                  >Descargar evidencia
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
          <v-layout> </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
export default {
  name: "grid-centro",
  components: {
    Loading,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      dialog: false,
      idEstado: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      contratoId: "",
      itemsProgreso: [],
      headers: [],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsCentro: [],
      regionValue: null,
      regionSelect: [],
      comunaValue: null,
      comunaSelect: [],
      estadoValue: null,
      estadoSelect: [],
      filter: false,
      evidencia: "",
    };
  },
  created() {
    // this.loading = true;
    //this.loadDataTemporal();
    this.loadDataEvidencia();
  },

  mounted() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;

    this.bloqueoEdicion(this.usuarioLoggedTipe);
  },
  computed: {},
  methods: {
    loadDataEvidencia() {
      if (this.$parent.$parent.$parent.tipeView != "consulta") {
        this.headers = [
          {
            text: "Tipo Documento",
            align: "left",
            sortable: false,
            value: "tipoDocumento",
          },
          { text: "Supervisor", sortable: false, value: "supervisor" },
        ];

        this.loadDataEvidenciaTemporal();
      } else {
        this.headers = [
          {
            text: "Tipo Documento",
            align: "left",
            sortable: false,
            value: "tipoDocumento",
          },
          { text: "Supervisor", sortable: false, value: "supervisor" },
          {
            text: "Accion",
            sortable: false,
            value: "accion",
          },
        ];
        this.loadDataEvidenciaAlmacenada();
      }
    },

    async loadDataEvidenciaTemporal() {
      this.loading = true;
      this.evidencia = await this.loadEvidenciaTemporalAll();
      this.loading = false;
      if (this.evidencia.length > 0) {
        this.$parent.alerta = false;
      } else {
        this.$parent.alerta = true;
      }
    },

    async loadEvidenciaTemporalAll() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      this.$parent.$parent.$parent.idCentro;
      return await axios
        .get(
          "/centro/evidencia/temporal/" +
            this.$parent.$parent.$parent.idCentro +
            "/" +
            idContrato
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    async loadDataEvidenciaAlmacenada() {
      this.loading = true;
      this.evidencia = await this.loadEvidenciaAlmacenadaAll();
      this.loading = false;
      if (this.evidencia.length > 0) {
        this.$parent.alerta = false;
      } else {
        this.$parent.alerta = true;
      }
    },

    async loadEvidenciaAlmacenadaAll() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      this.$parent.$parent.$parent.idCentro;
      return await axios
        .get(
          "/centro/evidencia/" +
            this.$parent.$parent.$parent.idCentro +
            "/" +
            idContrato
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    downloadEvidencia() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        fileName: "selecion/PruebaFichero.pdf",
        idContrato: idContrato,
      };

      axios
        .post("/centro/evidencia/create", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PruebaFichero.pdf");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
